import { QueryClient } from '@tanstack/react-query'

import { BrandItemViewModel, MenuViewModel } from '@/types/api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'
import { selectAPIService } from '@/app/_utils/select-api-service'

export const prefetchLayoutMenu = (queryClient: QueryClient) => {
    return queryClient.prefetchQuery({
        queryKey: QueryKeys.Layout.LayoutMenu,
        queryFn: async () => {
            const serviceName = selectAPIService().ntl

            const data: MenuViewModel = await fetchRequest({
                endpoint: `/layout/menu`,
                method: 'GET',
                serviceName,
            })

            // Recursively remove `logoUrl` from the data
            const removeLogoUrl = (menu: MenuViewModel): MenuViewModel => {
                const removeLogoFromBrands = (brands: BrandItemViewModel[] | null | undefined) =>
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    brands?.map(({ logoUrl, ...rest }) => rest)

                return {
                    ...menu,
                    brand: menu.brand
                        ? {
                              topBrands: removeLogoFromBrands(menu.brand.topBrands),
                          }
                        : undefined,
                }
            }

            return removeLogoUrl(data)
        },
    })
}
